import React from 'react'
import { Link } from 'react-router'

const Demo = () => {
  return (
 <> 
 <section id="demo" className="demo pt-90 pb-90">
            <div className="container">
                <div className="section-title text-center mb-25">
                
                    <h2 className="title mb-30 xb-split-text split-in-right">Unleashing Creativity,<br/><span> Strategy & Results</span></h2>
                    <p>Discover services designed to elevate your brand with professional excellence and innovative solutions.</p>
                </div>
                <ul className="demo-feature ul_li_center mb-70">
                    <li><span><img src="assets/img/icon/check.svg" alt=""/></span> Custom Strategies</li>
                    <li><span><img src="assets/img/icon/check.svg" alt=""/></span> Creative Innovations</li>
                    <li><span><img src="assets/img/icon/check.svg" alt=""/></span> Proven Results</li>
                </ul>
                <div className="row justify-content-center g-0">
                    <div className="col-lg-4 col-md-6">
                        <div className="xb-demo text-center">
                            <Link data-cursor-text="View" to="/web-development" ><img src="./assets/img/about/om-web-development.webp" alt=""/></Link>
                            <h3>Web Design Agency</h3>
                            <div className="xb-demo__shape">
                                <img className="shape" src="assets/img/shape/d_shape.png" alt=""/>
                                <img className="noise" src="assets/img/shape/d_noise.png" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="xb-demo text-center">
                            <Link data-cursor-text="View" to="/social-media-management" ><img src="./assets/img/about/om-smm-social-media-mangaement.webp" alt=""/></Link>
                            <h3>Social Media Management</h3>
                            <div className="xb-demo__shape">
                                <img className="shape" src="assets/img/shape/d_shape.png" alt=""/>
                                <img className="noise" src="assets/img/shape/d_noise.png" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-8">
                        <div className="xb-demo text-center">
                            <Link data-cursor-text="View" to="/digital-marketing" ><img src="./assets/img/about/om-digital-marketing.webp" alt=""/></Link>
                            <h3>Digital Marketing</h3>
                            <div className="xb-demo__shape">
                                <img className="shape" src="assets/img/shape/d_shape.png" alt=""/>
                                <img className="noise" src="assets/img/shape/d_noise.png" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
 </>
  )
}

export default Demo
